export const enTuttiModePlan = {
  taskReview: "Plan review",
  cancel: "Cancel plan",
  reviewHint: "Awaiting review",
  reviewHintReplan: "Preferences changed",
  materializingTitle: "Creating tasks",
  switchToSelfReview: "Switch to self review",
  switchingToSelfReview: "Switching to self review",
  selfReviewEnabled: "Self review enabled",
  selfReviewFailed: "Couldn't enable self review",
  materializingHint: "Turning the accepted plan into executable tasks",
  errorTitle: "Workflow unavailable",
  expand: "Expand workflow",
  collapse: "Collapse workflow",
  sendAccept: "Accept",
  sendRequestChanges: "Request changes",
  replanFeedback:
    "Preferences changed from effect {{fromEffect}} / speed {{fromSpeed}} to effect {{toEffect}} / speed {{toSpeed}}. Re-plan the model choices and effect-scaled task verification.",
  replanFeedbackSuffix:
    " (Preferences are now effect {{effect}} / speed {{speed}}; re-plan model choices and task verification accordingly.)",
  tasks: "Tasks",
  priority: "Priority",
  priorityHigh: "High",
  priorityMedium: "Medium",
  priorityLow: "Low",
  agentTarget: "Agent",
  model: "Model",
  permissionMode: "Permission mode",
  reasoningEffort: "Reasoning effort",
  parallelizable: "Parallel",
  autoAccept: "Auto-accept",
  assignmentOptionsLoading: "Loading options...",
  notSpecified: "Not specified",
  loadFailed: "Tutti mode plans could not be loaded",
  retry: "Try again",
  issueOpen: "Open Issue",
  issueListView: "List",
  issueBoardView: "Board",
  issueSummary: "{{done}}/{{total}} done · {{running}} running",
  issueDependencies: "Depends",
  issueAccept: "Accept",
  issueRework: "Rework",
  issueAcceptPrompt:
    "Review and accept {{reference}} in the current Tutti Mode plan. Verify its result and evidence, then continue the plan from the current execution state.",
  issueReworkPrompt:
    "Rework {{reference}} in the current Tutti Mode plan. Inspect the current execution and failure or acceptance evidence, preserve the original task history, then create a replacement task or a new follow-up execution as appropriate and continue scheduling.",
  issueStageParallel: "Stage {{index}} · parallel ×{{count}}",
  issueStageSequential: "Stage {{index}} · sequential",
  issueStatusNotStarted: "Todo",
  issueStatusRunning: "Running",
  issueStatusPendingAcceptance: "In review",
  issueStatusCompleted: "Done",
  issueStatusFailed: "Failed",
  issueStatusCanceled: "Canceled",
  issueStripRunning: "{{count}} subtasks running",
  issueStripPending: "{{count}} awaiting acceptance",
  issueStripFailed: "{{count}} failed",
  issueStripDone: "{{done}}/{{total}} done",
  issueCreateFailed:
    "The approved plan could not create its Issue: {{message}}. Ask the Agent to revise the plan."
} as const;
